import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, DateDecoder, field, NumberDecoder } from "@simonbackx/simple-encoding";
import { CustomerPrivate } from "./Customer";
import { OrderPrivate } from "./Order";
import { WholesalerPrivate } from "./Wholesaler";
import { Promotion } from "./Promotion";
export class PromotionView extends AutoEncoder {
}
__decorate([
    field({ decoder: CustomerPrivate })
], PromotionView.prototype, "customer", void 0);
__decorate([
    field({ decoder: DateDecoder })
], PromotionView.prototype, "createdAt", void 0);
export class PromotionStats extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.views = [];
        this.orders = [];
        this.wholesalers = [];
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(PromotionView) })
], PromotionStats.prototype, "views", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(OrderPrivate) })
], PromotionStats.prototype, "orders", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(WholesalerPrivate), version: 13 })
], PromotionStats.prototype, "wholesalers", void 0);
export class PromotionStatsForExport extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.orders = [];
    }
}
__decorate([
    field({ decoder: Promotion, version: 25 })
], PromotionStatsForExport.prototype, "promotion", void 0);
__decorate([
    field({ decoder: PromotionView, version: 25 })
], PromotionStatsForExport.prototype, "view", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(OrderPrivate), version: 25 })
], PromotionStatsForExport.prototype, "orders", void 0);
__decorate([
    field({ decoder: WholesalerPrivate, version: 25 })
], PromotionStatsForExport.prototype, "wholesaler", void 0);
__decorate([
    field({ decoder: NumberDecoder, version: 25 })
], PromotionStatsForExport.prototype, "totalViewsCount", void 0);
__decorate([
    field({ decoder: NumberDecoder, version: 25 })
], PromotionStatsForExport.prototype, "totalOrdersCount", void 0);
//# sourceMappingURL=PromotionStats.js.map